import { Link as GatsbyLink } from 'gatsby'
import styled from 'styled-components'

import RibbonSvg from '../../../../../../img/rewards/ribbon.inline.svg'

export const Description = styled.p`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
  }

  font-size: 16px;
  line-height: 1.17;
  margin-bottom: 22px;
`

export const IneligibleText = styled.p`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
  }

  font-size: 16px;
  line-height: 1.17;
  margin-top: 24px;
  margin-bottom: 0;
`

export const Label = styled.div<{ disabled?: boolean }>`
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-size: 14px;
  margin: 0;
  flex: 1;
  color: ${({ disabled, theme }) =>
    disabled ? theme.colors.text.secondary : theme.colors.text.primary};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`

export const VipDiscountText = styled.h4`
  color: ${({ theme }) => theme.colors.brand.blue};
  margin-bottom: 0;
`

export const VipDiscountPercentage = styled.h1`
  color: ${({ theme }) => theme.colors.brand.blue};
  font-size: 30px;
  margin-bottom: 0;
`

export const SmallDescription = styled.p`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
  }

  font-size: 12px;
  margin: 0;
  color: #818487;
  white-space: nowrap;
`

export const VipDiscountRibbon = styled(RibbonSvg)`
  display: block;
  width: 48px;
  height: 48px;
  margin-right: 8px;
  margin-top: 5px;
  margin-bottom: 5px;
`

export const Container = styled.div`
  display: flex;
  background-color: #f3f4f5;
  padding: 16px 32px;
  width: fit-content;
  min-width: 227px;
  border-radius: 8px;
`

export const LeftHalf = styled.div`
  display: flex;
  align-items: center;
`

export const RightHalf = styled.div`
  display: flex;
  flex-direction: column;
`

export const AlertContainer = styled.div`
  font-size: 14px;
  line-height: 1.25;
  border-radius: 8px;
  padding: 11px 15px;
  margin-bottom: 20px;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: flex-start;
  background-color: #48a2b01a;
  color: ${({ theme }) => theme.colors.grayscale.black};
`

export const AlertIconWrapper = styled.div`
  display: flex;
  align-self: center;
  margin-right: 15px;
  width: 25px;
`

export const AlertIcon = styled.img`
  width: 100%;
`

export const AlertContent = styled.div`
  width: 100%;
  margin: 6px 0;
`

export const Link = styled(GatsbyLink)`
  color: ${({ theme }) => theme.colors.royalBlue.shade500};
`

export const Email = styled.a`
  color: ${({ theme }) => theme.colors.royalBlue.shade500};
`
